export default class SkipLogic {
  diseases_skip_logic = []

  diseases_list = []
}
